import { Box, BoxProps } from "@mui/material";
import Blank from "../images/blank.png";

interface AdProps extends BoxProps {
    size?: string;
    visual: string;
    optional_mobile_visual?: string;
}

const Ad = ({ sx = {}, size, visual, optional_mobile_visual, ...rest }: AdProps) => {
    const randomNumber: number = Math.floor(Math.random() * 10000) + 1;
    return (
        <Box
            sx={{
                height: size !== `large` ? 150 : 250,
                display: `flex`,
                justifyContent: `center`,
                maxWidth: `100%`,
                overflow: `hidden`,
                borderRadius: size !== `large` ? 0 : 2.5,
                ...sx,
            }}
        >
            <Box
                id={randomNumber}
                onError={() => {
                    // Element is guaranteed to exist here - this IS the element that fired the error event
                    const el = document.getElementById(`${randomNumber}`) as HTMLImageElement;
                    el.onerror = null;
                    el.src = Blank;
                }}
                src={`${size !== `large` && optional_mobile_visual ? optional_mobile_visual : visual}`}
                sx={{
                    height: `100%`,
                    cursor: `pointer`,
                }}
                component="img"
                {...rest}
            />
        </Box>
    );
};

export default Ad;
